module.exports = __webpack_public_path__ + "static/media/status_alerta.26e3a502.svg";